export default "__VITE_ASSET__DZdDC8Lg__"